import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import {
  Button,
  Card,
  CardBody,
  Input,
  Row,
} from "reactstrap";
import { setSearch } from "../../redux/settings/actions";

import { Colxx } from "../../components/common/CustomBootstrap";
import { accessTypes } from "../../helpers/Utils";

class ListPageHeading extends Component {
  constructor(props) {
    super();
    this.state = {
      dropdownSplitOpen: false,
    };
  }


  render() {
    const {
      onSearchKey,
      toggleModal,
      heading,
      accessType,
      washerList,
      authUser,
      sortBanners,
      exportCSV,
      filterComponent,
      showCreateButton,
      customExportButton
    } = this.props;

    return (
      <Row>
        {/* Header Section */}
        <Colxx xxs="5" className="mb-3">
          {/* Left: Title */}
            <h1 className="mb-2 p-0">{heading}</h1>


        </Colxx>
        <Colxx xxs="7" className="mb-3">

          {/* Right: Action Buttons */}
          <div className="d-flex align-items-center justify-content-end">
            {sortBanners && (
              <Button
                color="dark"
                size="lg"
                outline
                className="mr-2"
                onClick={() => sortBanners()}
              >
                Sort {heading}
              </Button>
            )}

            {exportCSV && accessType !== 'admin' && !customExportButton && (
              <Button
                color="dark"
                size="lg"
                outline
                className="mr-2"
                onClick={exportCSV}
              >
                Export
              </Button>
            )}

            {customExportButton && accessType !== 'admin' && customExportButton()}

            {showCreateButton && (
              <Button
                color="primary"
                size="lg"
                onClick={() => toggleModal()}
              >
                Create New
              </Button>
            )}
          </div>
        </Colxx>

        {/* Filters Section */}
        {(filterComponent || onSearchKey || this.props.showSearch || (washerList && accessTypes.includes(authUser?.user?.accessType))) && (

          <Colxx xxs="12" className="mt-2">
            <Card className="mb-0">
              <CardBody className="pb-3">
                <Row>
                  {/* Search Input - Always show if showSearch is true or onSearchKey is provided */}
                  {(onSearchKey || this.props.showSearch) && (
                    <Colxx xxs="12" md={!filterComponent ? "12" : "3"} className='mb-3'>
                      <div className="search-sm">
                        <Input
                          type="text"
                          name="keyword"
                          id="search"
                          placeholder="Search"
                          value={this.props.search || ''}
                          onChange={e => {
                            const value = e.target.value;
                            if (onSearchKey) {
                              onSearchKey(e);
                            } else if (this.props.setSearch) {
                              this.props.setSearch(value);
                            }
                          }}
                        />
                        {this.props.search && (
                          <button
                            type="button"
                            className="search-clear"
                            onClick={() => {
                              if (onSearchKey) {
                                const event = { target: { value: '' } };
                                onSearchKey(event);
                              }
                              if (this.props.setSearch) {
                                this.props.setSearch('');
                              }
                            }}
                            aria-label="Clear search"
                          />
                        )}
                      </div>
                    </Colxx>
                  )}

                  {/* Filter Component (for new filtering pattern) */}
                  {filterComponent && (
                    // <div className="" style={{ gap: '12px', flex: 1 }}>
                    filterComponent
                    // </div>
                  )}


                  {/* </div> */}
                </Row>
              </CardBody>
            </Card>
          </Colxx>
        )}

        {/* Separator */}
        {/* {!hideSeparator && (
          <Colxx xxs="12">
            <Separator className="mb-2 mt-0" />
          </Colxx>
        )} */}
      </Row>
    );
  }
}

const mapStateToProps = ({ settings }) => {
  return {
    search: settings.search || '',
  };
};

export default injectIntl(
  connect(mapStateToProps, { setSearch })(ListPageHeading)
);
